import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import { DEFAULT_SCOPE_OPTIONS, urls } from '../Helpers/Const.js';

var useScopes = function useScopes(props) {
  var aosUrl = props.aosUrl,
    adfsToken = props.adfsToken,
    locale = props.locale;
  var c360ScopesUrl = urls.c360ScopesUrl;
  var headers = {
    headers: {
      Authorization: adfsToken,
      'x-account-locale': locale
    }
  };
  var _useState = useState(DEFAULT_SCOPE_OPTIONS),
    _useState2 = _slicedToArray(_useState, 2),
    scopeList = _useState2[0],
    setList = _useState2[1];
  useEffect(function () {
    fetch(aosUrl + c360ScopesUrl, headers).then(function (res) {
      return res.json();
    }).then(function (res) {
      setList(res.data);
    })["catch"](function () {
      setList(DEFAULT_SCOPE_OPTIONS);
    });
  }, []);
  return scopeList;
};

export { useScopes as default };
